<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormRequisicion" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Proveedor">Proveedor</label>
                                                <div class="input-group">
                                                    <input disabled v-model="objRequisicion.Proveedor" id="Proveedor" type="text" class="form-control" placeholder="Ingresar Proveedor">
                                                    <CValidation v-if="this.errorvalidacion.Proveedor" :Mensaje="'*'+errorvalidacion.Proveedor[0]"/>
                                                    <button v-if="BuscarProveedor" @click="AbrirModalProveedor" class="btn btn-outline-primary boder-extend" type="button"><i class="fas fa-search" id="button-addon2"></i></button>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Contacto">Contacto</label>
                                                <input v-model="objRequisicion.Contacto" id="Contacto" type="text" class="form-control" placeholder="Ingresar Contacto">
                                                <CValidation v-if="this.errorvalidacion.Contacto" :Mensaje="'*'+errorvalidacion.Contacto[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="CorreoContacto">Correo</label>
                                                <input v-model="objRequisicion.CorreoContacto" id="CorreoContacto" type="text" class="form-control" placeholder="Ingresar CorreoContacto">
                                                <CValidation v-if="this.errorvalidacion.CorreoContacto" :Mensaje="'*'+errorvalidacion.CorreoContacto[0]"/>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Contacto">Departamento Solicitante</label>
                                                <select class="form-control form-select" v-model="objRequisicion.Departamento" id="Departamento">
                                                    <option value="">-- Selecciona un Departamento --</option>
                                                    <option v-for="(item,index) in Departamentos" :key="index" :value="item.Nombre">{{ item.Nombre }}</option>
                                                </select>
                                                <CValidation v-if="this.errorvalidacion.Departamento" :Mensaje="'*'+errorvalidacion.Departamento[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Contacto">Fecha de Recepción</label>
                                                <div class="calendar">
                                                    <Datepicker v-model="objRequisicion.FechaRecep" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" :disabled-dates="Setpicker.DisabledDates" placeholder="0000-00-00"></Datepicker>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Contacto">Moneda</label>
                                                <input v-model="objRequisicion.PrecioMoneda" id="PrecioMoneda" type="text" class="form-control" placeholder="Ingresar Tipo de Moneda o Denominación">
                                                <CValidation v-if="this.errorvalidacion.PrecioMoneda" :Mensaje="'*'+errorvalidacion.PrecioMoneda[0]"/>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                                <label for="">¿Existe Cotización?</label>
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <div class="form-check">
                                                            <input type="radio" v-model="BndCotizacionProveedor" class="form-check-input" name="flexRadioDefault" id="flexRadioDefault1" value="1" @change="ActivarCotizacionProveedor">
                                                            <label class="form-check-label" for="flexRadioDefault1">
                                                                SI
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                        <div class="form-check">
                                                            <input type="radio" v-model="BndCotizacionProveedor" class="form-check-input" name="flexRadioDefault" id="flexRadioDefault2" value="2" @change="ActivarCotizacionProveedor">
                                                            <label class="form-check-label" for="flexRadioDefault2">
                                                                NO
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                                                <label for="Contacto">Folio de Cotización</label>
                                                <input :disabled="DesactivarCotizacionProveedor" v-model="objRequisicion.CotProveedor" id="CotProveedor" type="text" class="form-control" placeholder="Ingresar Folio">
                                                <CValidation v-if="this.errorvalidacion.CotProveedor" :Mensaje="'*'+errorvalidacion.CotProveedor[0]"/>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                                                <label for="Contacto">Condicion de Pago</label>
                                                <input v-model="objRequisicion.CondicionPago" id="CondicionPago" type="text" class="form-control" placeholder="Ingresar Condicion de Pago">
                                                <CValidation v-if="this.errorvalidacion.CondicionPago" :Mensaje="'*'+errorvalidacion.CondicionPago[0]"/>
                                            </div>
                                        </div>

                                        <div v-if="AgregarMaterial" class="form-group row">
                                            <div class="col-lg-12">
                                                <button :disabled="!BndSeleccionarMateriales" @click="AbrirModalMaterial" class="btn btn-01"><i class="fa fa-plus-circle"></i> Agregar</button>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-lg-12">
                                                <div class="table-responsive">
                                                    <table class="table align-items-center mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Cantidad</th>
                                                                <th>Material</th>
                                                                <th>Unidad</th>
                                                                <th>Sub Unidad</th>
                                                                <th>Descripción</th>
                                                                <th>Precio Unit.</th>
                                                                <th>Importe</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item,index) in MaterialesSeleccionados" :key="index">
                                                                <td>
                                                                    <input v-model="item.Cantidad" type="text" class="form-control" @input="$onlyNums($event,item,'Cantidad');CalcularImporte(item)">
                                                                </td>
                                                                <td>
                                                                    <textarea disabled v-model="item.Nombre" class="form-control" cols="30" rows="3"></textarea>
                                                                    <!-- <input disabled v-model="item.Nombre" type="text" class="form-control"> -->
                                                                </td>
                                                                <td>
                                                                    <select v-model="item.IdUnidad" @change="ListaSubUnidades(item,index);CambiarUnidad(item)" class="form-control form-select" :id="'UnidadMaterial'+index">
                                                                        <option value="">Selecciona una Opción</option>
                                                                        <option v-for="(unidad,index2) in item.Unidades" :value=unidad.IdUnidadMaterial :key="index2">{{ unidad.Nombre }}</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <select v-model="item.IdSubUnidad" @change="CambiarSubUnidad(item)" class="form-control form-select" :id="'SubUnidadMaterial'+index">
                                                                        <option value="">Selecciona una Opción</option>
                                                                        <option v-for="(subunidad,index3) in item.SubUnidades" :value="subunidad.IdSubUnidadMaterial" :key="index3">{{ subunidad.Cantidad + ' ' + subunidad.SubUnidad }}</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <textarea v-model="item.Descripcion" cols="30" rows="3" class="form-control"></textarea>
                                                                </td>
                                                                <td>
                                                                    <input v-model="item.PrecioUnitario" @input="$number_decimal($event,item,'PrecioUnitario');CalcularImporte(item)" type="text" class="form-control">
                                                                </td>
                                                                <td>
                                                                    <input disabled v-model="item.Importe" type="text" class="form-control">
                                                                </td>
                                                                <td></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-lg-12">
                                                <div class="row">
                                                    <div class="col-lg-9">
                                                        <div class="row">
                                                            <label class="col-lg-8 col-form-label"></label>
                                                            <label class="col-lg-1 col-form-label text-right" style="padding-left:0;">
                                                                Descuento %
                                                            </label>
                                                            <div class="col-2 col-lg-2">
                                                                <input v-model="objRequisicion.DescPorcent" @input="$onlyNums($event,objRequisicion,'DescPorcent');CalcularSubTotal()" type="text" class="form-control form-control-sm">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <div class="row mb-3">
                                                           <label for="" class="col-lg-4 col-form-label">Descuento $:</label>
                                                           <div class="col-lg-7">
                                                            <input v-model="objRequisicion.Descuento" disabled type="text" class="form-control form-control-sm">
                                                           </div> 
                                                        </div>

                                                        <div class="row mb-3">
                                                            <label for="" class="col-lg-4 col-form-label">Sub Total:</label>
                                                            <div class="col-lg-7">
                                                             <input v-model="objRequisicion.SubTotal" disabled type="text" class="form-control form-control-sm">
                                                            </div> 
                                                         </div>

                                                         <div class="row mb-3">
                                                            <label for="" class="col-lg-4 col-form-label">I.V.A.:</label>
                                                            <div class="col-lg-7">
                                                             <input v-model="objRequisicion.ValorIva" disabled type="text" class="form-control form-control-sm">
                                                            </div> 
                                                         </div>

                                                         <div class="row">
                                                            <label for="" class="col-lg-4 col-form-label">Total:</label>
                                                            <div class="col-lg-7">
                                                             <input v-model="objRequisicion.Total" disabled type="text" class="form-control form-control-sm">
                                                            </div> 
                                                         </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="col-lg-3"></div> -->
                                        </div>
                                        <CBtnSave :poBtnSave="oBtnSave" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModalProveedor" :poBtnSave="oBtnSaveProveedor">
            <template slot="Form">
                <FormProveedor :poBtnSave="oBtnSaveProveedor" :pProveedorSeleccionado="ProveedorSeleccionado"></FormProveedor>
            </template>
        </CModal>
        <CModal :pConfigModal="ConfigModalMaterial" :poBtnSave="oBtnSaveMaterial">
            <template slot="Form">
                <FormMaterial :poBtnSave="oBtnSaveMaterial" :pMaterialesSeleccionados="MaterialesSeleccionados" :pIdProveedor="objRequisicion.IdProveedor"></FormMaterial>
            </template>
        </CModal>
    </div>
</template>

<script>
import Calendar from '@/helpers/StaticComboBox.js';

import moment from 'moment';
import FormProveedor from '../requisicion/ProveedoresModal.vue';
import FormMaterial from '../requisicion/MaterialesModal.vue';
const EmitEjecuta = 'seccionRequisicion';
const EmitEjecuta2 = 'seccionProveedor';
const EmitEjecuta3 = 'seccionMaterial';
export default {
    name: 'FormRequisicion',
    props: ['Id'],
    components:{
        FormProveedor,
        FormMaterial
    },
    data() {
        return {
            ConfigList:{
                Title: 'Formulario',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: 'Requisicion',
				EmitSeccion: EmitEjecuta,
            },
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModalProveedor:{
                ModalTitle: "Asignar Proveedor",
                ModalNameId: 'ModalFormProveedor',
                EmitSeccion: EmitEjecuta2,
                ModalSize:'xl',
                ShowFooter:false
            },
            ConfigModalMaterial:{
                ModalTitle: "Asignar Material",
                ModalNameId: 'ModalFormMaterial',
                EmitSeccion: EmitEjecuta3,
                ModalSize:'xl',
                ShowFooter:false
            },
            oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'Requisicion',
                EmitSeccion: EmitEjecuta,
                ShowBtnSave:true
            },
            oBtnSaveProveedor:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
            },
            oBtnSaveMaterial:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
            objRequisicion:{
                IdRequisicion:0,
                Folio:'',
                IdProveedor:0,
                Proveedor:'',
                Contacto:'',
                CorreoContacto:'',
                Departamento:'',
                FechaRecep:'',
                PrecioMoneda:'',
                CotProveedor:'',
                CondicionPago:'',
                Elaboro:0,
                FechaExp:'',
                Recibio:0,
                Autorizo:0,
                FechaAutorizacion:'',
                EstatusAutorizado:'',
                Motivo:'',
                Estatus:'',
                DescPorcent:'',
                Descuento:0,
                SubTotal:0,
                Iva:0.16,
                ValorIva:0,
                Total:0,
                ExistCotz:'',
                FechaRecibido:'',
            },
            segurity: {},
            errorvalidacion: [],
			Emit: EmitEjecuta,
            Setpicker:Calendar.calendarSettings,
            Departamentos:[],
            BndCotizacionProveedor:'',
            ProveedorSeleccionado:{},
            MaterialesSeleccionados:[],
            BndSeleccionarMateriales:false,
            DesactivarCotizacionProveedor:true,
            BuscarProveedor:true,
            AgregarMaterial:true
        }
    },
    methods: {
        async Guardar()
        {
            this.errorvalidacion = [];
            let BndError = false;
            let Mensaje = "";

            if(this.objRequisicion.IdProveedor == 0){
                this.$toast.warning('Debe Seleccionar Un Proveedor');
                return false;
            }
            if(this.MaterialesSeleccionados.length == 0){
                Mensaje = 'Debe Seleccionar Al Menos Un Material';
                BndError=true;
            }

            this.MaterialesSeleccionados.every(element => {
                if (element.Cantidad=="") {
                    Mensaje='La Cantidad del Material ' + element.Nombre + " No Puede Estar Vacía";
                    BndError=true;
                    return false;
                }
                if (element.IdUnidad=="") {
                    Mensaje='La Unidad del Material ' + element.Nombre + " No Puede Estar Vacía";
                    BndError=true;
                    return false;
                }
                if (element.IdSubUnidad=="") {
                    Mensaje='La Sub Unidad del Material ' + element.Nombre + " No Puede Estar Vacía";
                    BndError=true;
                    return false;
                }
                if (element.PrecioUnitario=="" || element.PrecioUnitario==0) {
                    Mensaje='El Precio Unitario del Material ' + element.Nombre + " No Puede Estar Vacío";
                    BndError=true;
                    return false;
                }
                return true;
            });

            if (BndError) {
                this.$toast.warning(Mensaje);
                return false;
            }

            let FechaRecep='';
            if (this.objRequisicion.FechaRecep!='' && this.objRequisicion.FechaRecep!=undefined) {
                let day=this.objRequisicion.FechaRecep.getDate();
                let month=this.objRequisicion.FechaRecep.getMonth()+1;
                let year=this.objRequisicion.FechaRecep.getFullYear();
                FechaRecep = year+'-'+month+'-'+day;   
            }
            this.objRequisicion.ExistCotz=this.BndCotizacionProveedor==1 ? 'si' : 'no';
            
            this.oBtnSave.DisableBtn = true;
            
            let formData=new FormData();
            formData.set('IdRequisicion',this.objRequisicion.IdRequisicion);
            formData.set('Folio',this.objRequisicion.Folio);
            formData.set('IdProveedor',this.objRequisicion.IdProveedor);
            formData.set('Proveedor',this.objRequisicion.Proveedor);
            formData.set('Contacto',this.objRequisicion.Contacto);
            formData.set('CorreoContacto',this.objRequisicion.CorreoContacto);
            formData.set('Departamento',this.objRequisicion.Departamento);
            formData.set('FechaRecep',FechaRecep);
            formData.set('PrecioMoneda',this.objRequisicion.PrecioMoneda);
            formData.set('CotProveedor',this.objRequisicion.CotProveedor);
            formData.set('CondicionPago',this.objRequisicion.CondicionPago);
            formData.set('Recibio',this.objRequisicion.Recibio);
            formData.set('Autorizo',this.objRequisicion.Autorizo);
            formData.set('FechaAutorizacion',this.objRequisicion.FechaAutorizacion);
            formData.set('EstatusAutorizado',this.objRequisicion.EstatusAutorizado);
            formData.set('Motivo',this.objRequisicion.Motivo);
            formData.set('Estatus',this.objRequisicion.Estatus);
            formData.set('DescPorcent',this.objRequisicion.DescPorcent);
            formData.set('Descuento',this.objRequisicion.Descuento);
            formData.set('SubTotal',this.objRequisicion.SubTotal);
            formData.set('Iva',this.objRequisicion.Iva);
            formData.set('ValorIva',this.objRequisicion.ValorIva);
            formData.set('Total',this.objRequisicion.Total);
            formData.set('ExistCotz',this.objRequisicion.ExistCotz);
            formData.set('FechaRecibido',this.objRequisicion.FechaRecibido);
            formData.set('Materiales',JSON.stringify(this.MaterialesSeleccionados));

            if (this.objRequisicion.IdRequisicion==0) {
                await this.$http.post('requisiciones',formData,{
                    headers: {
					'Content-Type': 'multipart/form-data'
				}
                }
                ).then((res) => {
                    this.EjecutaConExito(res);
                }).catch((err) => {
                    this.EjecutaConError(err);
                });
            }
            else
            {
                await this.$http.post('requisiciones/'+this.objRequisicion.IdRequisicion,formData,{
                    headers: {
					'Content-Type': 'multipart/form-data'
				    }
                }).then((res) => {
                    this.EjecutaConExito(res);
                }).catch((err) => {
                    this.EjecutaConError(err);
                });
            }
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get('requisiciones/'+this.objRequisicion.IdRequisicion
            ).then((res)=>{
                this.objRequisicion=res.data.data;
                let objRequisicion=this.objRequisicion;
                Object.keys(this.objRequisicion).forEach(function(key,ind){
                    if (objRequisicion[key]==null) {
                        objRequisicion[key]="";
                    }
                })
                let formatedDate = res.data.data.FechaRecep.replace(/-/g, "\/");
                this.objRequisicion.FechaRecep=new Date(formatedDate);
                this.BndCotizacionProveedor=this.objRequisicion.ExistCotz=='si' ? '1' : '2';
                this.DesactivarCotizacionProveedor=this.BndCotizacionProveedor=='1' ? false : true;
                this.ProveedorSeleccionado.IdProveedor=this.objRequisicion.IdProveedor;
                res.data.detalle.forEach(element => {
                    element.Nombre=element.Material;
                    element.Unidades=[];
                    element.SubUnidades=[];
                    this.ListaUnidades(element);
                    this.ListaSubUnidades(element);
                });
                this.MaterialesSeleccionados=res.data.detalle;
                if (res.data.data.Estatus=="AUTORIZACION") {
                    this.oBtnSave.ShowBtnSave=false;
                }
            }).finally(()=>{
                this.BndSeleccionarMateriales=true;
                this.ConfigLoad.ShowLoader=false;
            })
        },
        Limpiar(){

        },
        Regresar(){
            this.$router.push({name:this.oBtnSave.ReturnRoute});
        },
        async ListarDepartamentos(){
            await this.$http.get('departamentosSimple'
            ).then((res)=>{
                this.Departamentos=res.data.data;
            })
        },
        ActivarCotizacionProveedor(){
            if (this.BndCotizacionProveedor=="1") {
                this.DesactivarCotizacionProveedor=false;
            }
            else{
                this.DesactivarCotizacionProveedor=true;
                this.objRequisicion.CotProveedor='';
            }
        },
        AbrirModalProveedor(){
            this.bus.$emit('NewModal_'+this.ConfigModalProveedor.EmitSeccion,0);
        },
        AbrirModalMaterial(){
            this.bus.$emit('NewModal_'+this.ConfigModalMaterial.EmitSeccion,0);
        },
        SeleccionarProveedor(item){
            this.BndSeleccionarMateriales   = true;
            this.ProveedorSeleccionado      = item;
            this.MaterialesSeleccionados    = [];

            this.objRequisicion.IdProveedor     = this.ProveedorSeleccionado.IdProveedor;
            this.objRequisicion.Proveedor       = this.ProveedorSeleccionado.RazonSocial;
            this.objRequisicion.Contacto        = this.ProveedorSeleccionado.Contacto;
            this.objRequisicion.CorreoContacto  = this.ProveedorSeleccionado.Correo;
            this.bus.$emit('CloseModal_'+this.ConfigModalProveedor.EmitSeccion);
        },
        SeleccionarMaterial(item){
            this.ListaUnidades(item);
            this.bus.$emit('CloseModal_'+this.ConfigModalMaterial.EmitSeccion);
        },
        ListaUnidades(item){
            this.MaterialesSeleccionados.push(item);
            this.$http.get("/materialespresentacionproveedor/unidades",{
                params:{
                    IdArticuloAlmacen: item.IdArticuloAlmacen,
                    IdProveedor:this.ProveedorSeleccionado.IdProveedor
                }
            }).then((res)=>{
                item.Unidades=res.data.data;
            })
        },
        async ListaSubUnidades(opcion,index){
            await this.$http.get('subUnidadesMaterial/simple',{
                params:{
                    IdUnidadMaterial:opcion.IdUnidad
                }
            }).then((res)=>{
                opcion.SubUnidades=res.data.data;
            });
        },
        CambiarUnidad(item){
            let Indice=item.Unidades.findIndex((element)=>element.IdUnidadMaterial==item.IdUnidad);
            item.Unidad=item.Unidades[Indice].Nombre;
        },
        CambiarSubUnidad(item){
            let Indice=item.SubUnidades.findIndex((element)=>element.IdSubUnidadMaterial==item.IdSubUnidad);
            item.SubUnidad=item.SubUnidades[Indice].Cantidad+' '+item.SubUnidades[Indice].SubUnidad;
        },
        CalcularImporte(item){
            // CALCULO INDIVIDUAL DE IMPORTE DE UN MATERIAL
            let Total=parseFloat(item.PrecioUnitario)*parseFloat(item.Cantidad);
            item.Importe=isNaN(Total) ? 0 : Number(Total).toFixed(2);
            this.CalcularSubTotal();
        },
        CalcularSubTotal(){
            let SubTotal=0;
            this.MaterialesSeleccionados.forEach((element)=>{
                if (element.Importe=='') {
                    element.Importe=0;
                }
                SubTotal+=Number(parseFloat(element.Importe));
            });
            this.objRequisicion.SubTotal=SubTotal.toFixed(2);
            if (this.objRequisicion.DescPorcent!='') {
                let Descuento=Number((this.objRequisicion.DescPorcent/100)*this.objRequisicion.SubTotal);
                this.objRequisicion.Descuento=isNaN(Descuento) ? 0 : Descuento.toFixed(2);
            }
            else{
                this.objRequisicion.Descuento=0;
            }
            this.CalcularTotal();
        },

        CalcularTotal(){
            if (this.objRequisicion.DescPorcent!='') {
                this.objRequisicion.SubTotal-=this.objRequisicion.Descuento;
            }
            // TOTAL CON IVA
            let ValorIva=Number(parseFloat(this.objRequisicion.SubTotal)*parseFloat(this.objRequisicion.Iva));
            this.objRequisicion.ValorIva=isNaN(ValorIva) ? 0 : ValorIva.toFixed(2);
            let Total=Number(parseFloat(this.objRequisicion.SubTotal)+parseFloat(this.objRequisicion.ValorIva));
            this.objRequisicion.Total=isNaN(Total) ? 0 : Total.toFixed(2);
        }
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);
        this.bus.$off('SeleccionarProveedor');
        this.bus.$off('SeleccionarMaterial');
    },
    mounted() {
        this.oBtnSave.DisableBtn = false;
        this.Limpiar();

        if(this.Id!='') 
        {
            this.BuscarProveedor=false;
            this.AgregarMaterial=false;
            this.objRequisicion.IdRequisicion = this.Id;
            this.Recuperar();
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
        this.bus.$on('SeleccionarProveedor',(item)=>{
            this.SeleccionarProveedor(item);
        });
        this.bus.$on('SeleccionarMaterial',(item)=>{
            this.SeleccionarMaterial(item);
        });
        this.ListarDepartamentos();
    },
}
</script>

<style>

</style>